<template>
	<div class="cmbc_table bg_FFFFFF width_100">
		<naviBack type='time_table' title="酒店名称" background="#ffffff" />

		<div class="ds_body width_100">
			<div :class="[{'ds_body_blockS':select_course.length>0},'ds_body_block width_100 bg_FFFFFF']">
				<div class="ds_body_panel width_fit text_ellipsis2 display_start_start">
					<div class="ds_body_panel_head bg_FFFFFF">
						<div class="ds_body_panel_head_1 width_100"></div>
						<div v-for="(ctl_item,ctl_index) in course_time_list" :key="'course_list'+ctl_index"
							class="ds_body_panel_head_2 width_100 display_center_center font_size_28 color_333333">
							<div :class="[{'ds_body_panel_head_2_item':ctl_index>0}]">{{ctl_index%2==0?ctl_item:'　'}}
							</div>
						</div>

					</div>
					<div v-for="(cl_item,cl_index) in course_list" :key="'course_list'+cl_index"
						class="ds_body_panel_block">
						<div
							class="ds_body_panel_block_title bg_FFFFFF width_100 font_size_28 color_333333 display_center_center">
							{{cl_item.siteName}}
						</div>

						<div v-for="(cil_item,cil_index) in cl_item.priceItems" :key="'cil'+cil_index" 
						:class="[{'ds_body_panel_block_body_select color_ffffff':cil_item.is_select},
						{'ds_body_panel_block_bodyS color_F77F28':cil_item.bookStatus==1},
						{'ds_bpbb_30':cil_item.cell_unit==30},
						{'ds_bpbb_29':cil_item.cell_unit==29},
						{'ds_bpbb_28':cil_item.cell_unit==28},
						{'ds_bpbb_27':cil_item.cell_unit==27},
						{'ds_bpbb_26':cil_item.cell_unit==26},
						{'ds_bpbb_25':cil_item.cell_unit==25},
						{'ds_bpbb_24':cil_item.cell_unit==24},
						{'ds_bpbb_23':cil_item.cell_unit==23},
						{'ds_bpbb_22':cil_item.cell_unit==22},
						{'ds_bpbb_21':cil_item.cell_unit==21},
						{'ds_bpbb_20':cil_item.cell_unit==20},
						{'ds_bpbb_19':cil_item.cell_unit==19},
						{'ds_bpbb_18':cil_item.cell_unit==18},
						{'ds_bpbb_17':cil_item.cell_unit==17},
						{'ds_bpbb_16':cil_item.cell_unit==16},
						{'ds_bpbb_15':cil_item.cell_unit==15},
						{'ds_bpbb_14':cil_item.cell_unit==14},
						{'ds_bpbb_13':cil_item.cell_unit==13},
						{'ds_bpbb_12':cil_item.cell_unit==12},
						{'ds_bpbb_11':cil_item.cell_unit==11},
						{'ds_bpbb_10':cil_item.cell_unit==10},
						{'ds_bpbb_9':cil_item.cell_unit==9},
						{'ds_bpbb_8':cil_item.cell_unit==8},
						{'ds_bpbb_7':cil_item.cell_unit==7},
						{'ds_bpbb_6':cil_item.cell_unit==6},
						{'ds_bpbb_5':cil_item.cell_unit==5},
						{'ds_bpbb_4':cil_item.cell_unit==4},
						{'ds_bpbb_3':cil_item.cell_unit==3},
						{'ds_bpbb_2':cil_item.cell_unit==2},'width_100 ds_body_panel_block_body display_center_center font_size_30']"
							@click="selectTimetable(cil_item)">
							<img v-if="cil_item.bookStatus!=1" src="../resource/logo_ffffff.png" alt="" />
							<img v-if="cil_item.bookStatus==1 && cil_item.is_select" src="../resource/logo_ffffff.png" alt="" />
							<img v-if="cil_item.bookStatus==1 && !cil_item.is_select" src="../resource/logo_f77f28.png" alt="" />
						</div>
					</div>
				</div>
				<div class="ds_body_panel_seat"></div>
			</div>
		</div>
		
		<div class="ds_bottom width_100 bg_FFFFFF">
			<div class="ds_tip width_100">
				<div class="width_100 display_start_center">
					<div class="ds_tip_item display_center_center color_666666 font_size_18">
						<div class="ds_tip_item_1 display_center_center">
							<img src="../resource/logo_f77f28.png" alt="" />
						</div>
						可预订
					</div>
					<div class="ds_tip_item display_center_center color_666666 font_size_18">
						<div class="ds_tip_item_2 display_center_center">
							<img src="../resource/logo_ffffff.png" alt="" />
						</div>
						已订满
					</div>
					<div class="ds_tip_item display_center_center color_666666 font_size_18">
						<div class="ds_tip_item_3 display_center_center">
							<img src="../resource/logo_ffffff.png" alt="" />
						</div>
						已选择
					</div>
				</div>
				<div v-if="select_course.length>0" class="ds_tip_title color_333333 font_size_26">已选场次</div>
				<div v-if="select_course.length>0" class="ds_tip_list width_100">
					<div class="ds_tip_list_item width_fit text_ellipsis2 display_start_center">
						<div v-for="(co_item,co_index) in select_course" :key="'course'+co_index"
							class="ds_tip_list_block border_radius_8">
							<div class="ds_tip_list_block_1 display_center_center color_ffffff font_size_20 bg_F77F28 width_100">1号场地</div>
							<div class="ds_tip_list_block_2 display_center_center color_333333 font_size_22 width_100">07:00-08:00</div>
						</div>
					</div>
				</div>
			</div>
			<div class="ds_bottom_price width_100">
				<div class="ds_bottom_price_item display_center_center font_size_32 color_ffffff">提交订单</div>
			</div>
		</div>

	</div>
</template>

<script>
	import naviBack from '../components/navi_back.vue';
	export default {
		components: {
			naviBack
		},
		name: "",
		data() {
			return {
				course_time_list: ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00',
					'12:30',
					'13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
					'18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30'
				], //课表[左侧时间]
				course_list: [], //课表
				
				select_course_max:3,// 最多可选课程数量
				select_course: [], //已选课程
			};
		},
		mounted() {
			var course_list = [
				{
					"siteNo": "9239812279745",
					"siteName": "1号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 1,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 1,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 4,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279745",
						"siteName": "1号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279746",
					"siteName": "2号场地",
					"priceItems": [{
						"bookStatus": 0,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279746",
						"siteName": "2号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279747",
					"siteName": "3号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279747",
						"siteName": "3号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279748",
					"siteName": "4号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279748",
						"siteName": "4号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279749",
					"siteName": "5号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279749",
						"siteName": "5号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279750",
					"siteName": "6号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279750",
						"siteName": "6号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279751",
					"siteName": "7号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279751",
						"siteName": "7号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279752",
					"siteName": "8号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279752",
						"siteName": "8号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279753",
					"siteName": "9号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}, {
						"bookStatus": 0,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279753",
						"siteName": "9号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279754",
					"siteName": "10号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279754",
						"siteName": "10号场地",
						"is_select": false
					}]
				}, {
					"siteNo": "9239812279755",
					"siteName": "11号场地",
					"priceItems": [{
						"bookStatus": 1,
						"price": 52,
						"beginTime": "08:00",
						"endTime": "09:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 52,
						"beginTime": "09:00",
						"endTime": "10:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "10:00",
						"endTime": "11:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "11:00",
						"endTime": "12:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "12:00",
						"endTime": "13:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "13:00",
						"endTime": "14:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "14:00",
						"endTime": "15:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "15:00",
						"endTime": "16:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "16:00",
						"endTime": "17:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "17:00",
						"endTime": "18:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "18:00",
						"endTime": "19:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 87,
						"beginTime": "19:00",
						"endTime": "20:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "20:00",
						"endTime": "21:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}, {
						"bookStatus": 1,
						"price": 58,
						"beginTime": "21:00",
						"endTime": "22:00",
						"cell_unit": 2,
						"siteNo": "9239812279755",
						"siteName": "11号场地",
						"is_select": false
					}]
				},
			]
			console.log(course_list);
			this.course_list = course_list
		},
		methods: {
			// 选择课表
			selectTimetable(e) {
				if (e.bookStatus != 1) { // 状态为1，则可继续操作，否则中断操作
					return
				}
				if (!e.is_select) { //选中
					if (this.select_course.length >= this.select_course_max) { // 判断最多可选课程数量
						this.$toast('最多可选' + this.select_course.length + '场次');
						return
					}
					e.is_select = true
					this.select_course = [...this.select_course, ...[e]]
				} else { //取消选中
					// 课表中取消选择
					this.course_list.map((item_1) => {
						item_1.priceItems.map((item_2) => {
							if (item_2.siteNo == e.siteNo && item_2.beginTime == e.beginTime) {
								item_2.is_select = false
							}
						})
					})
					// 删除已选场次
					var targetIndex = this.select_course.findIndex(item => item.siteNo === e.siteNo && item.beginTime == e
						.beginTime);
					this.select_course.splice(targetIndex, 1);
				}
			},
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;
	.cmbc_table{
		min-height: 100vh;
		background-color: #F6F7F9;
	}
	.cmbc_table_body {
		margin-top: 20*@vm_base;
	}
	.ds_body {
		padding-bottom: 360*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2);
		margin-top: 20*@vm_base;
		.ds_body_block {
			overflow: hidden;
			overflow-x: auto;
			overflow-y: auto;
			height: calc(100vh - 380*@vm_base - 80*@vm_base + 30*@vm_base - 30*@vm_base - 0*@vm_base);
		}

		.ds_body_blockS {
			height: calc(100vh - 380*@vm_base - 152*@vm_base - 80*@vm_base + 30*@vm_base - 30*@vm_base - 00*@vm_base);
		}

		.ds_body_panel {
			position: relative;

			.ds_body_panel_head {
				position: sticky;
				left: 0;
				z-index: 2;
				width: 134*@vm_base;
				margin-right: 2*@vm_base;

				.ds_body_panel_head_1 {
					height: 78*@vm_base;
					margin-bottom: 2*@vm_base;
				}

				.ds_body_panel_head_2 {
					height: 40*@vm_base;
					// border: 1*@vm_base solid red;
					margin-bottom: 10*@vm_base;

					&:last-child {
						margin-bottom: 0;
						height: 0;
					}

					&:nth-last-child(2) {
						height: 0;
						// margin-bottom: 0;
					}

					.ds_body_panel_head_2_item {
						margin-top: -40*@vm_base;
					}
				}


			}

			.ds_body_panel_block {
				width: 150*@vm_base;
				margin-right: 10*@vm_base;

				.ds_body_panel_block_title {
					position: sticky;
					top: 0;
					left: 0;
					z-index: 1;
					height: 78*@vm_base;
					margin-bottom: 2*@vm_base;
					border: 1*@vm_base solid #fff;
				}

				.ds_body_panel_block_body {
					height: 40*@vm_base;
					margin-bottom: 10*@vm_base;
					border: 1*@vm_base solid #D9D9D9;
					background: #D9D9D9;
					border-radius: 8*@vm_base;
					padding-left: 12*@vm_base;
					&:last-child {
						margin-bottom: 0;
					}

					img {
						width: 68.75%;
						height: 68.75%;
						// margin-left: 12*@vm_base;
						object-fit: contain;
					}
				}

				.ds_body_panel_block_bodyS {
					background: none;
					border: 1*@vm_base solid #F77F28;
				}

				.ds_body_panel_block_body_select {
					border: 1*@vm_base solid #f77f28;
					background-color: #f77f28;
				}

				// 此处为2-20个单位的高度   [基础高度*数量 + 间距*间距数量]
				.ds_bpbb_2 {
					height: calc(40*@vm_base * 2 + 10*@vm_base * (2 - 1));
				}

				.ds_bpbb_3 {
					height: calc(40*@vm_base * 3 + 10*@vm_base * (3 - 1));
				}

				.ds_bpbb_4 {
					height: calc(40*@vm_base * 4 + 10*@vm_base * (4 - 1));
				}

				.ds_bpbb_5 {
					height: calc(40*@vm_base * 5 + 10*@vm_base * (5 - 1));
				}

				.ds_bpbb_6 {
					height: calc(40*@vm_base * 6 + 10*@vm_base * (6 - 1));
				}

				.ds_bpbb_7 {
					height: calc(40*@vm_base * 7 + 10*@vm_base * (7 - 1));
				}

				.ds_bpbb_8 {
					height: calc(40*@vm_base * 8 + 10*@vm_base * (8 - 1));
				}

				.ds_bpbb_9 {
					height: calc(40*@vm_base * 9 + 10*@vm_base * (9 - 1));
				}

				.ds_bpbb_10 {
					height: calc(40*@vm_base * 10 + 10*@vm_base * (10 - 1));
				}

				.ds_bpbb_11 {
					height: calc(40*@vm_base * 11 + 10*@vm_base * (11 - 1));
				}

				.ds_bpbb_12 {
					height: calc(40*@vm_base * 12 + 10*@vm_base * (12 - 1));
				}

				.ds_bpbb_13 {
					height: calc(40*@vm_base * 13 + 10*@vm_base * (13 - 1));
				}

				.ds_bpbb_14 {
					height: calc(40*@vm_base * 14 + 10*@vm_base * (14 - 1));
				}

				.ds_bpbb_15 {
					height: calc(40*@vm_base * 15 + 10*@vm_base * (15 - 1));
				}

				.ds_bpbb_16 {
					height: calc(40*@vm_base * 16 + 10*@vm_base * (16 - 1));
				}

				.ds_bpbb_17 {
					height: calc(40*@vm_base * 17 + 10*@vm_base * (17 - 1));
				}

				.ds_bpbb_18 {
					height: calc(40*@vm_base * 18 + 10*@vm_base * (18 - 1));
				}

				.ds_bpbb_19 {
					height: calc(40*@vm_base * 19 + 10*@vm_base * (19 - 1));
				}

				.ds_bpbb_20 {
					height: calc(40*@vm_base * 20 + 10*@vm_base * (20 - 1));
				}

				.ds_bpbb_21 {
					height: calc(40*@vm_base * 21 + 10*@vm_base * (21 - 1));
				}

				.ds_bpbb_22 {
					height: calc(40*@vm_base * 22 + 10*@vm_base * (22 - 1));
				}

				.ds_bpbb_23 {
					height: calc(40*@vm_base * 23 + 10*@vm_base * (23 - 1));
				}

				.ds_bpbb_24 {
					height: calc(40*@vm_base * 24 + 10*@vm_base * (24 - 1));
				}

				.ds_bpbb_25 {
					height: calc(40*@vm_base * 25 + 10*@vm_base * (25 - 1));
				}

				.ds_bpbb_26 {
					height: calc(40*@vm_base * 26 + 10*@vm_base * (26 - 1));
				}

				.ds_bpbb_27 {
					height: calc(40*@vm_base * 27 + 10*@vm_base * (27 - 1));
				}

				.ds_bpbb_28 {
					height: calc(40*@vm_base * 28 + 10*@vm_base * (28 - 1));
				}

				.ds_bpbb_29 {
					height: calc(40*@vm_base * 29 + 10*@vm_base * (29 - 1));
				}

				.ds_bpbb_30 {
					height: calc(40*@vm_base * 30 + 10*@vm_base * (30 - 1));
				}
			}
		}

		.ds_body_panel_seat {
			height: 8*@vm_base;
		}
	}
	.ds_bottom {
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 3;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2);
		box-shadow: 0*@vm_base -4*@vm_base 8*@vm_base 0*@vm_base rgba(247, 127, 40, .1);
	
		.ds_tip {
			padding: 30*@vm_base 20*@vm_base;
			border-bottom: 1*@vm_base solid #D9D9D9;
	
			.ds_tip_item {
				margin-right: 30*@vm_base;
	
				.ds_tip_item_1 {
					margin-right: 10*@vm_base;
					width: 50*@vm_base;
					height: 30*@vm_base;
					border-radius: 4*@vm_base;
					border: 1*@vm_base solid #f77f28;
					padding-left: 6*@vm_base;
					img{
						width: 78%;
						height: 78%;
						object-fit: contain;
					}
				}
	
				.ds_tip_item_2 {
					margin-right: 10*@vm_base;
					width: 50*@vm_base;
					height: 30*@vm_base;
					border-radius: 4*@vm_base;
					background: #D9D9D9;
					border: 1*@vm_base solid #D9D9D9;
					padding-left: 6*@vm_base;
					img{
						width: 78%;
						height: 78%;
						object-fit: contain;
					}
				}
	
				.ds_tip_item_3 {
					margin-right: 10*@vm_base;
					width: 50*@vm_base;
					height: 30*@vm_base;
					border-radius: 4*@vm_base;
					background: #f77f28;
					border: 1*@vm_base solid #f77f28;
					padding-left: 6*@vm_base;
					img{
						width: 78%;
						height: 78%;
						object-fit: contain;
					}
				}
			}
	
			.ds_tip_title {
				margin-top: 20*@vm_base;
			}
	
			.ds_tip_list {
				margin-top: 20*@vm_base;
				overflow: hidden;
				overflow-x: auto;
	
				&::-webkit-scrollbar {
					width: 0;
					height: 0;
				}
	
				.ds_tip_list_item {
					min-width: 100%;
				}
	
				.ds_tip_list_block {
					width: 180*@vm_base;
					margin-right: 20*@vm_base;
					border: 1*@vm_base solid #f77f28;
					overflow: hidden;
	
					&:last-child {
						margin-right: 0;
					}
	
					.ds_tip_list_block_1 {
						height: 36*@vm_base;
					}
	
					.ds_tip_list_block_2 {
						height: 50*@vm_base;
					}
				}
			}
		}
	
		.ds_bottom_price {
			padding: 20*@vm_base 75*@vm_base;
			.ds_bottom_price_item{
				background: linear-gradient( 233deg, #FB8027 0%, #FFA663 100%);
				height: 80*@vm_base;
				border-radius: 40*@vm_base;
			}
		}
	}
</style>




<!-- 
 
 [{"siteNo":"9239812279745","siteName":"1号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":1,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279745","siteName":"1号场地","is_select":false}]},{"siteNo":"9239812279746","siteName":"2号场地","priceItems":[{"bookStatus":0,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279746","siteName":"2号场地","is_select":false}]},{"siteNo":"9239812279747","siteName":"3号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279747","siteName":"3号场地","is_select":false}]},{"siteNo":"9239812279748","siteName":"4号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279748","siteName":"4号场地","is_select":false}]},{"siteNo":"9239812279749","siteName":"5号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279749","siteName":"5号场地","is_select":false}]},{"siteNo":"9239812279750","siteName":"6号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279750","siteName":"6号场地","is_select":false}]},{"siteNo":"9239812279751","siteName":"7号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279751","siteName":"7号场地","is_select":false}]},{"siteNo":"9239812279752","siteName":"8号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279752","siteName":"8号场地","is_select":false}]},{"siteNo":"9239812279753","siteName":"9号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":0,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":0,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false},{"bookStatus":0,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279753","siteName":"9号场地","is_select":false}]},{"siteNo":"9239812279754","siteName":"10号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279754","siteName":"10号场地","is_select":false}]},{"siteNo":"9239812279755","siteName":"11号场地","priceItems":[{"bookStatus":1,"price":52,"beginTime":"08:00","endTime":"09:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":52,"beginTime":"09:00","endTime":"10:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"10:00","endTime":"11:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"11:00","endTime":"12:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"12:00","endTime":"13:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"13:00","endTime":"14:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"14:00","endTime":"15:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"15:00","endTime":"16:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"16:00","endTime":"17:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"17:00","endTime":"18:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"18:00","endTime":"19:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":87,"beginTime":"19:00","endTime":"20:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"20:00","endTime":"21:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false},{"bookStatus":1,"price":58,"beginTime":"21:00","endTime":"22:00","cell_unit":2,"siteNo":"9239812279755","siteName":"11号场地","is_select":false}]}]
 -->


// WEBPACK FOOTER //
// src/views/time_table.vue